import styled from 'styled-components';
import { ob, bp } from 'components/Onboarding';

export const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  h1 {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: ${ob.text};
    ${bp.sm} {
      font-size: 26px;
    }
  }
`;

export const PreviewPill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 16px;
  border: 1px solid rgba(255, 113, 15, 0.3);
  border-radius: 999px;
  background: rgba(255, 240, 230, 0.7);
  box-shadow: 0 1px 2px rgba(26, 26, 26, 0.05);
  color: ${ob.primary};
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 140ms ease;
  &:hover {
    background: ${ob.primarySoft};
    border-color: rgba(255, 113, 15, 0.5);
  }
`;

export const ReviewCard = styled.div`
  padding: 12px;
  border: 1px solid ${ob.border};
  border-radius: 22px;
  background: #fff;
  box-shadow: ${ob.shadowCard};
  ${bp.sm} {
    padding: 18px;
  }
`;

export const Mosaic = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
  .cover {
    grid-column: 1 / -1;
  }
  ${bp.md} {
    grid-template-columns: 2.6fr 1fr;
    grid-template-rows: 1fr 1fr;
    height: 320px;
    .cover {
      grid-column: 1;
      grid-row: 1 / 3;
    }
  }
  .tile {
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    background: ${ob.mutedBg};
    min-height: 100px;
  }
  .tile img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .cover {
    min-height: 180px;
  }
  .more {
    position: absolute;
    right: 12px;
    bottom: 12px;
    padding: 4px 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    font-size: 12px;
    font-weight: 600;
  }
  .edit {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .empty {
    display: grid;
    place-items: center;
    font-size: 40px;
  }
`;

/** One size for every Edit button on the review page. */
export const EditPill = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  min-width: 68px;
  padding: 0 12px;
  border: 1px solid ${ob.border};
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(26, 26, 26, 0.06);
  color: ${ob.text};
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: all 140ms ease;
  svg {
    flex-shrink: 0;
    color: ${ob.primary};
  }
  &:hover {
    border-color: rgba(255, 113, 15, 0.45);
    background: ${ob.primarySoft};
  }
`;
export const Body = styled.div`
  display: grid;
  gap: 24px;
  margin-top: 20px;
  ${bp.lg} {
    grid-template-columns: minmax(0, 1fr) 300px;
    gap: 24px;
    align-items: start;
  }
`;

export const Main = styled.div`
  min-width: 0;
`;

export const HeadRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  .name {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 19px;
    font-weight: 600;
    line-height: 1.2;
    color: ${ob.text};
    ${bp.sm} {
      font-size: 23px;
    }
  }
  .where {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
    font-size: 13px;
    color: ${ob.muted};
    svg {
      flex-shrink: 0;
    }
  }
  .kind {
    margin-top: 4px;
    font-size: 12.5px;
    color: ${ob.muted};
  }
  .edits {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  margin-top: 14px;
  padding: 12px 0;
  border-top: 1px solid ${ob.border};
  border-bottom: 1px solid ${ob.border};
  font-size: 13px;
  font-weight: 500;
  .stat {
    display: flex;
    align-items: center;
    gap: 8px;
    svg {
      color: ${ob.primary};
    }
  }
  .edit {
    margin-left: auto;
  }
`;

export const BlockRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  .grow {
    min-width: 0;
    flex: 1;
  }
  h2 {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 16px;
    font-weight: 600;
    color: ${ob.text};
  }
  .text {
    margin: 0;
    font-size: 13px;
    line-height: 1.65;
    color: ${ob.muted};
    word-break: break-word;
  }
  & + & {
    border-top: 1px solid ${ob.border};
  }
`;

export const Lines = styled.div`
  margin-top: 4px;
  p {
    margin: 0 0 6px;
    font-size: 13px;
    line-height: 1.65;
    color: ${ob.muted};
  }
`;

export const Offers = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
  .chip {
    padding: 6px 14px;
    border: 1px solid ${ob.border};
    border-radius: 999px;
    font-size: 12.5px;
    color: ${ob.text};
    background: #fff;
  }
`;

export const LiveNote = styled.p`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px 0 0;
  font-size: 13px;
  color: ${ob.muted};
  svg {
    color: ${ob.primary};
  }
`;

export const Aside = styled.aside`
  padding: 16px;
  border: 1px solid ${ob.border};
  border-radius: 18px;
  background: ${ob.surface};
  ${bp.lg} {
    position: sticky;
    top: 96px;
  }
  .top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .price {
    font-family: ${ob.fontDisplay};
    font-size: 23px;
    font-weight: 700;
    color: ${ob.text};
    small {
      font-family: ${ob.fontBody};
      font-size: 13px;
      font-weight: 400;
      color: ${ob.muted};
    }
  }
  .weekend {
    margin: 10px 0 0;
    font-size: 13px;
    color: ${ob.muted};
  }
  .box {
    margin-top: 12px;
    padding: 12px 14px;
    border: 1px solid ${ob.border};
    border-radius: 12px;
    background: #fff;
  }
  .box .head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }
  .box h3 {
    margin: 0;
    font-family: ${ob.fontDisplay};
    font-size: 14px;
    font-weight: 600;
  }
  .box p {
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.6;
    color: ${ob.muted};
  }
  .pay {
    margin: 12px 0 0;
    font-size: 13px;
    color: ${ob.muted};
  }
  .reserve {
    width: 100%;
    height: 44px;
    margin-top: 14px;
    border: 0;
    border-radius: 999px;
    background: ${ob.primary};
    color: #fff;
    font-family: inherit;
    font-size: 14.5px;
    font-weight: 600;
    opacity: 0.5;
    cursor: not-allowed;
  }
  .only {
    margin: 8px 0 0;
    text-align: center;
    font-size: 12px;
    color: ${ob.muted};
  }
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0 40px;
`;
